import NutritionDetailsEditField from './NutritionDetailsEditField';

export default NutritionDetailsEditField;
